import { useContext } from "react";
import { ensure, mapToDropdownOption } from "sprint-common-web";

import { LanguagesDataContext } from "../../../../../common/data/lookup-data-providers/LanguagesDataProvider";
import { useLanguageSpecificationApi } from "../../../../../common/api/orders-api/language-specification/useLanguageSpecificationApi";
import { LanguageSpecificationDashboardContext } from "../../context/LanguageSpecificationDashboardContext";
import { LanguageSpecificationDashboardItem } from "../../LanguageSpecificationDashboardItem";
import { EditLanguageCodeMappingFormInputs } from "./EditMappingFormInputs";

export const useEditLanguageCodeMappingForm = (languageId: string) => {
    const { updateLanguageSpecificationMapping } = useLanguageSpecificationApi();

    const { languageSpecificationDashboardItem, updateMappingItem } = useContext(LanguageSpecificationDashboardContext);
    const { languages } = useContext(LanguagesDataContext);

    const languageOptions = languages.map((lang) => mapToDropdownOption(lang));

    const itemToEdit = getItemToEdit(languageSpecificationDashboardItem, languageId);

    const editMapping = async ({ languageId: id, soundtrackCode, subtitleCode }: EditLanguageCodeMappingFormInputs) => {
        await updateLanguageSpecificationMapping({
            languageSpecificationId: languageSpecificationDashboardItem.id,
            languageId: id,
            soundtrackCode,
            subtitleCode
        });

        updateMappingItem({
            languageId: id,
            soundtrackCode,
            subtitleCode
        });
    };

    return {
        languageOptions,
        itemToEdit,
        editMapping
    };
};

const getItemToEdit = (languageSpecificationItem: LanguageSpecificationDashboardItem, languageId: string) => {
    const itemToEdit = languageSpecificationItem.mappings.find((mapping) => mapping.languageId === languageId);

    ensure(itemToEdit);

    return itemToEdit;
};
